import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Badge, Card, CardBody, CardHeader, Col, Pagination, PaginationItem, PaginationLink, Row, Table } from 'reactstrap';

import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';
import 'chartjs-plugin-labels';
//import 'chartjs-plugin-datalabels';

import {Widget, AnalyticFilterForm} from './Widget';

// Actions
import { checkAuth } from '../../actions/sessionActions';

import { UserContext } from '../../shared/context/user';
import { ThemeContext } from '../../shared/context/theme';

var colors = ["#0f358e","#1d3557","#457b9d","#a8dadc","#f1faee","#f91f43","#e76f51","#f4a261","#e9c46a","#f4e3b8", "#2A9D8F"];

const optionsDark = {
                      layout: {
                        padding: {
                          top: 10
                        }
                      },
                      legend: {
                        display: false,
                        labels: {
                          // This more specific font property overrides the global property
                          fontColor: '#F3A261'
                        }
                      },
                      scales: {
                        xAxes: [{
                          barPercentage: 0.4,
                          gridLines: {color: '#404147'},
                          ticks: {fontColor: '#939AA1'}
                        }],
                        yAxes: [{
                          barPercentage: 0.4,
                          gridLines: {color: '#404147'},
                          ticks: {fontColor: '#939AA1'}
                        }],
                      },
                      plugins: {
                        labels: {
                          render: 'value',
                          fontColor: '#447D9B',
                        }
                      }
                    }
const optionsLight =  {
                        layout: {
                          padding: {
                            top: 10
                          }
                        },
                        legend: {
                          display: false,
                          labels: {
                            // This more specific font property overrides the global property
                            fontColor: 'black'
                          }
                        },
                        scales: {
                          xAxes: [{
                            barPercentage: 0.4,
                            gridLines: {color: 'rgba(0,0,0,0.05)'},
                            ticks: {fontColor: 'black'}
                          }],
                          yAxes: [{
                            barPercentage: 0.4,
                            gridLines: {color: 'rgba(0,0,0,0.05)'},
                            ticks: {fontColor: 'black'}
                          }],
                        },
                        plugins: {
                          labels: {
                            render: 'value',
                            fontColor: '#F3A261',
                          }
                        }
                      }
const barData = {
        datasets: [{
            label: 'Chart',
            data: [10, 20, 30, 40, 15, 20, 30, 59, 11, 59, 5, 2],
            fontColor: 'red',
            //backgroundColor: 'rgba(0,0,0,0.5)',
            //backgroundColor: colors,
            lineTension: 0,
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'darkorange',
            pointBackgroundColor: 'rgba(255,255,255,0.5)',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 10  
        }
        ],
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
const doughnutData = {
        datasets: [{
            label: 'Chart',
            data: [10, 20, 30, 40],
            fontColor: 'red',
            //backgroundColor: 'rgba(0,0,0,0.5)',
            backgroundColor: colors
        }
        ],
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    } 
const doughnutOptions = {
                      layout: {
                        padding: {
                          top: 10
                        }
                      },
                      legend: {
                        display: false,
                        labels: {
                          // This more specific font property overrides the global property
                          fontColor: '#F3A261'
                        }
                      },
                      scales: {
                        xAxes: [{
                          display: false,
                          barPercentage: 0.4,
                          gridLines: {color: '#404147'},
                          ticks: {fontColor: '#939AA1'}
                        }],
                        yAxes: [{
                          display: false,
                          barPercentage: 0.4,
                          gridLines: {color: '#404147'},
                          ticks: {fontColor: '#939AA1'}
                        }],
                      },
                      plugins: {
                        labels: {
                          render: 'value',
                          fontColor: '#447D9B',
                        }
                      }
                    }       
const lineData = {
        datasets: [{
            label: 'Chart',
            data: [10, 20, 30, 40, 15, 20, 30, 59, 11, 43, 10, 2],
            fontColor: 'red',
            //backgroundColor: 'rgba(0,0,0,0.5)',
            //backgroundColor: colors,
            borderColor: '#447D9B',
            borderWidth: 1,
            lineTension: 0,
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#447D9B',
            pointBackgroundColor: 'rgba(255,255,255,1.5)',
            pointBorderWidth: 2,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 10  
        },
        {
            label: 'Chart 1',
            data: [15, 30, 20, 10, 35, 10, 40, 49, 21, 39, 15, 21],
            fontColor: 'red',
            //backgroundColor: 'rgba(0,0,0,0.5)',
            //backgroundColor: colors,
            borderColor: 'orange',
            borderWidth: 1,
            lineTension: 0,
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#E99908',
            pointBackgroundColor: 'rgba(255,255,255,1.5)',
            pointBorderWidth: 2,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 4,
            pointHitRadius: 10  
        }
        ],
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }


class Customer extends Component {
  
  constructor(props) {
    super(props);
    var options = optionsLight;
    if(localStorage.getItem('theme')=='dark') {
      options = optionsDark;
    }
    this.state = {
      theme: 'light',
      barOptions: options,
      doughnutOptions: doughnutOptions
    };
  }
  componentDidMount() {
    this.setState({theme: this.context.theme.theme});
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.theme != this.context.state.theme) {
      this.setState({theme: this.context.state.theme});
      if(this.context.state.theme=='dark') {
        this.setState({barOptions: this.state.barOptions = optionsDark});  
      }
      else {
        this.setState({barOptions: this.state.barOptions = optionsLight}); 
      }
    }  
  }
  
  render() {
    
    const session = this.props.session
    if(typeof(session.forceLogout)!="undefined" && session.forceLogout==1) {
      this.setState({session: null});
      window.location.href="/login";
    }

    return (
      <UserContext.Consumer>
      { user => (
      <div className="analytic mb-5">
        <div className="row">

          <div className="col-12"><AnalyticFilterForm /></div>
          
          <div className="col-12 col-sm-6">
            <div className="panel-filled">           
              <h5 className="mb-3">No of Registered Users</h5>
              <Line
                data={lineData}
                width={100}
                height={35}
                options={this.state.barOptions}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6">
            <div className="panel-filled">           
              <h5 className="mb-3">Active Users</h5>
              <Line
                data={lineData}
                width={100}
                height={35}
                options={this.state.barOptions}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6">
            <div className="panel-filled">           
              <h5 className="mb-3">User Activity Groups</h5>
              <Line
                data={lineData}
                width={100}
                height={35}
                options={this.state.barOptions}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6">
            <div className="panel-filled">           
              <h5 className="mb-3">All Time Activity</h5>
              <Doughnut
                data={doughnutData}
                width={100}
                height={35}
                options={this.state.doughnutOptions}
              />
            </div>
          </div>
          
          <div className="col-12 col-sm-6">
            <div className="panel-filled">           
              <h5 className="mb-3">Conversions % (Transactions/Clicks)</h5>
              <Line
                data={lineData}
                width={100}
                height={35}
                options={this.state.barOptions}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6">
            <div className="panel-filled">           
              <h5 className="mb-3">Cancellations Ratios</h5>
              <Line
                data={lineData}
                width={100}
                height={35}
                options={this.state.barOptions}
              />
            </div>
          </div>

          <div className="col-12 col-sm-6">
            <div className="panel-filled">
              <h5 className="mb-3">Top 10 Categories</h5>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Last run</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td> Apido Import</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                </tbody>
              </table>
              </div>
          </div>

          <div className="col-12 col-sm-6">
            <div className="panel-filled">
              <h5 className="mb-3">Top 10 Brands</h5>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Last run</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td> Apido Import</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                </tbody>
              </table>
              </div>
          </div>

          <div className="col-12 col-sm-6">
            <div className="panel-filled">
              <h5 className="mb-3">Top 10 Customers by Turnover</h5>
              <table className="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Last run</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                <tr>
                  <td> Apido Import</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                <tr>
                  <td> finAPI Sync</td>
                  <td> 11/10/2020 23:01</td>
                  <td><span>Successful</span></td>
                </tr>
                </tbody>
              </table>
              </div>
          </div>
          <div className="col-12 col-sm-6">
            <div className="panel-filled">           
              <h5 className="mb-3">Payment Medium Popularity</h5>
              <Doughnut
                data={doughnutData}
                width={100}
                height={35}
                options={this.state.doughnutOptions}
              />
            </div>
          </div>

        </div>
      </div>
      )}
      </UserContext.Consumer>
    );
  }
}

function mapStateToProps(state) {
    return {
      isMobile: state.device.isMobile,
      session: state.session      
    }
  };

const mapDispatchToProps = dispatch => bindActionCreators({checkAuth}, dispatch);
Customer.contextType = ThemeContext;
export default connect(
        mapStateToProps,
        mapDispatchToProps
        )(Customer);
